<div [formGroup]="form" [readonly]="!canEdit">
  <div class="row" *ngIf="hasSupplierPim && isOwnProduct">
    <div class="col-6 no-padding">
      <form-field
        dialog
        for="retailChain"
        label="cards.products.product_packaging_edit_transport_unit.label.retailer"
        [validationResultType]="isFieldInvalid(ProductUnitField.RetailChain, form.get('retailChain').value)"
      >
        <lxm-select
          select
          class="w-full"
          for="retailChain"
          [searchable]="true"
          [options]="formData.retailChains"
          [sortByLabel]="true"
          [readonly]="!canEdit"
        >
        </lxm-select>
        <validation-errors for="retailChain"></validation-errors>
        <validation-errors for="retailChainId"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding"></div>
  </div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_ordering.label"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_ordering"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsOrderUnit, form.get('isOrderUnit').value)"
      >
        <slide-toggle toggle for="isOrderUnit" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isOrderUnit"></validation-errors>
      </form-field>
      <form-field
        dialog
        for="minOrderCount"
        *ngIf="form.value.isOrderUnit"
        label="cards.products.product_packaging_edit_basic_unit.label.min_order_count"
        description="cards.products.product_packaging_edit_basic_unit.label_description.min_order_count"
        [validationResultType]="isFieldInvalid(ProductUnitField.MinOrderCount, form.get('minOrderCount').value)"
      >
        <lxm-input
          class="dialog-input-fixed-width-1"
          for="minOrderCount"
          type="numeric"
          [allowNegativeNumbers]="false"
          [readonly]="!canEdit"
          [digits]="2"
        ></lxm-input>
        <!-- <combined-input any class="dialog-input-fixed-width-1" for="minOrderCount">
          <span suffix>{{form.value.pickingUnitId | translateEnum:'UnitShort'}}</span>
        </combined-input> -->
        <validation-errors for="minOrderCount"></validation-errors>
      </form-field>
      <form-field
        dialog
        for="minOrderCountMultiplier"
        *ngIf="form.value.isOrderUnit"
        label="cards.products.product_packaging_edit_basic_unit.label.min_order_count_multiplier"
        description="cards.products.product_packaging_edit_basic_unit.label_description.min_order_count_multiplier"
        [validationResultType]="isFieldInvalid(ProductUnitField.MinOrderCountMultiplier, form.get('minOrderCountMultiplier').value)"
      >
        <lxm-input
          class="dialog-input-fixed-width-1"
          for="minOrderCountMultiplier"
          type="numeric"
          [allowNegativeNumbers]="false"
          [readonly]="!canEdit"
          [digits]="2"
        ></lxm-input>
        <validation-errors for="minOrderCountMultiplier"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_is_inventory_unit.label"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_is_inventory_unit"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsInventoryUnit, form.get('isInventoryUnit').value)"
      >
        <slide-toggle toggle for="isInventoryUnit" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isInventoryUnit"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 no-padding"></div>
  </div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field
        dialog
        labelTop="true"
        label="cards.products.product_packaging_edit_transport_unit.label.unit_code"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_code"
        [validationResultType]="isFieldInvalid(ProductUnitField.Codes, form.get('codes').value)"
      >
        <product-code-manager
          any
          for="codes"
          [readonly]="!canEdit"
          small="true"
          [codeTypes]="codeTypes"
        ></product-code-manager>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field
        dialog
        labelTop="true"
        label="cards.products.product_packaging_edit_transport_unit.label.unit_tare"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_tare"
        [required]="this.main.type.id === ProductUnitType.TransportUnit ? canEdit : false" [validationResultType]="isFieldInvalid(ProductUnitField.Tares, form.get('tares').value)"
      >
        <tare-manager
          any
          for="tares"
          [readonly]="!canEdit"
          [tareOptions]="formData.tareTypes"
        ></tare-manager>
        <validation-errors for="tares"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-12 no-padding">
      <form-field
        dialog
        labelTop="true"
        label="cards.products.product_packaging_edit_transport_unit.label.package_material"
        description="cards.products.product_packaging_edit_transport_unit.label_description.package_material"
        [validationResultType]="productValidity.shouldValidate ? isFieldInvalid(ProductUnitField.PackageMaterials, form.get('packageMaterials').value) : (canEdit ? ValidationResultType.Recommended : ValidationResultType.None)"
      >
        <package-material-manager
          any
          for="packageMaterials"
          [readonly]="!canEdit"
          [materialOptions]="formData.packageMaterialTypes"
          [readonly]="!canEdit"
        ></package-material-manager>
      </form-field>
    </div>
  </div>

  <div class="separator"></div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_contained"
        for="subUnit"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_contained"
        [required]="canEdit" [validationResultType]="isFieldInvalid(ProductUnitField.SubUnit, form.get('subUnit').value)"
      >
        <lxm-select
          select
          class="w-full"
          for="subUnit"
          [options]="subUnits"
          [clearable]="false"
          [readonly]="!canEdit"
        >
          <validation-errors
            for="subUnitId"
            aliasTo="subUnit"
          ></validation-errors>
        </lxm-select>
      </form-field>
    </div>

    <div class="col-6 no-padding justify-center">
      <form-field
        dialog
        for="subUnitCount"
        label="cards.products.product_packaging_edit_transport_unit.label.unit_count"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_count"
        [required]="canEdit" [validationResultType]="isFieldInvalid(ProductUnitField.SubUnitCount, form.get('subUnitCount').value)"
      >
        <combined-input
          any
          class="dialog-input-fixed-width-1"
          for="subUnitCount"
        >
          <!-- <span suffix>{{'enums.UnitShort.Piece' | translate}}</span> -->
          <validation-errors for="subUnitCount"></validation-errors>
        </combined-input>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_net_weight"
        for="netWeight_g"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_net_weight"
        [validationResultType]="isFieldInvalid(ProductUnitField.NetWeight, form.get('netWeight_g').value)"
      >
        <combined-input
          any
          class="dialog-input-fixed-width-1"
          for="netWeight_g"
          [readonly]="true"
        >
          <span suffix>{{'enums.UnitShort.Gram' | translate}}</span>
          <validation-errors for="netWeight_g"></validation-errors>
        </combined-input>
      </form-field>

      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_gross_weight"
        for="grossWeight_g"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_gross_weight"
        [validationResultType]="isFieldInvalid(ProductUnitField.GrossWeight, form.get('grossWeight_g').value)"
      >
        <combined-input
          combined
          class="dialog-input-fixed-width-1"
          for="grossWeight_g"
          [readonly]="true"
        >
          <span suffix>{{'enums.UnitShort.Gram' | translate}}</span>
          <validation-errors for="grossWeight_g"></validation-errors>
        </combined-input>
      </form-field>
    </div>

    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_height"
        for="height_mm"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_height"
        [required]="canEdit" [validationResultType]="isFieldInvalid(ProductUnitField.Height, form.get('height_mm').value)"
      >
        <combined-input
          combined
          class="dialog-input-fixed-width-1"
          for="height_mm"
          [readonly]="!canEdit"
        >
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="height_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_width"
        for="width_mm"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_width"
        [required]="canEdit" [validationResultType]="isFieldInvalid(ProductUnitField.Width, form.get('width_mm').value)"
      >
        <combined-input
          combined
          class="dialog-input-fixed-width-1"
          for="width_mm"
          [readonly]="!canEdit"
        >
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="width_mm"></validation-errors>
        </combined-input>
      </form-field>

      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_length"
        for="length_mm"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_length"
        [required]="canEdit" [validationResultType]="isFieldInvalid(ProductUnitField.Length, form.get('length_mm').value)"
      >
        <combined-input
          combined
          class="dialog-input-fixed-width-1"
          for="length_mm"
          [readonly]="!canEdit"
        >
          <span suffix>{{'enums.UnitShort.Millimeter' | translate}}</span>
          <validation-errors for="length_mm"></validation-errors>
        </combined-input>
      </form-field>
    </div>
  </div>

  <card-message type="error" *ngIf="!subUnitHasNetAndGrossWeight" class="mb10">
    {{ 'cards.products.product_packaging.sub_unit_invalid_warning' | translate}}
  </card-message>

  <card-message type="warning" class="mb10" *ngIf="packageCapacityCheckFailed">
    {{ packageCapacityCheckError.value | translate:
    packageCapacityCheckError.args }}
  </card-message>

  <div class="separator"></div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_packaging_returnable.label"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_packaging_returnable"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsReturnablePackage, form.get('isReturnablePackage').value)"
      >
        <slide-toggle toggle for="isReturnablePackage" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isReturnablePackage"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding"></div>
  </div>

  <div class="row align-center">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_basic_unit.label.unit_is_package_reusable"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_is_package_reusable"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsReusablePackage, form.get('isReusablePackage').value)"
      >
        <slide-toggle toggle for="isReusablePackage" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isReusablePackage"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding">
      <form-field
        dialog
        for="packageName"
        type="input-text"
        label="cards.products.product_packaging_edit_basic_unit.label.unit_package_name"
        description="cards.products.product_packaging_edit_basic_unit.label_description.unit_package_name"
        [validationResultType]="isFieldInvalid(ProductUnitField.PackageName, form.get('packageName').value)"
      >
        <validation-errors for="packageName"></validation-errors>
      </form-field>
    </div>
  </div>

  <div class="row">
    <div class="col-6 no-padding">
      <form-field
        dialog
        label="cards.products.product_packaging_edit_transport_unit.label.unit_shelf_ready.label"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_shelf_ready"
        [validationResultType]="isFieldInvalid(ProductUnitField.IsShelfReadyPackage, form.get('isShelfReadyPackage').value)"
      >
        <slide-toggle toggle for="isShelfReadyPackage" [readonly]="!canEdit"></slide-toggle>
        <validation-errors for="isShelfReadyPackage"></validation-errors>
      </form-field>
    </div>
    <div class="col-6 no-padding">
      <form-field
        dialog
        *ngIf="form.get('isShelfReadyPackage')?.value"
        for="productFaceCount"
        label="cards.products.product_packaging_edit_transport_unit.label.unit_facings"
        description="cards.products.product_packaging_edit_transport_unit.label_description.unit_facings"
        [validationResultType]="isFieldInvalid(ProductUnitField.ProductFaceCount, form.get('productFaceCount').value)"
      >
        <input
          input
          class="lxm-input dialog-input-fixed-width-1"
          formControlName="productFaceCount"
          type="text"
        />
        <validation-errors for="productFaceCount"></validation-errors>
      </form-field>
    </div>
  </div>
</div>
